import { IconChevron } from 'components/Icons';
import { useState, useEffect } from 'react';
import { metricsPeriodPlot } from '../Dashboard/DParser/types';
import { logger } from '../KSExport/reportNTParser/utils';
import classNames from 'classnames';
import { formatRangeValues } from 'lib/reportUtils';

const PeriodSelector = ({
  periods,
  weekly,
  selectedPeriod,
  onChangePeriod,
}: {
  periods: metricsPeriodPlot[];
  weekly: boolean;
  selectedPeriod: number;
  onChangePeriod: (period: number) => void;
}) => {
  if (periods.length === 0) {
    return null;
  }
  const [currentPeriod, setCurrentPeriod] = useState(selectedPeriod);
  const [title, setTitle] = useState<string | undefined>(periods[currentPeriod].periodTitle);

  const handleForwardClick = () => {
    if (currentPeriod > 0) setCurrentPeriod(currentPeriod - 1);
  };

  const handleBackClick = () => {
    if (currentPeriod < periods.length - 1) setCurrentPeriod(currentPeriod + 1);
  };

  useEffect(() => {
    // Update the title based on the current period
    const start = periods[currentPeriod].date.start;
    const end = periods[currentPeriod].date.end;
    const formattedStart = formatRangeValues(start && end ? `${start} - ${end}` : start, 'KS');
    const year = new Date().getFullYear();
    const yearTitle =
      periods[currentPeriod].periodTitle.indexOf(year + '') > -1
        ? periods[currentPeriod].periodTitle
        : periods[currentPeriod].periodTitle + ` ${year}`;
    setTitle(weekly ? formattedStart || periods[currentPeriod].periodTitle : yearTitle);
    onChangePeriod(currentPeriod);
  }, [currentPeriod]);

  return (
    <div className="ks-dashboard-chart__header">
      <div
        className={classNames('ks-dashboard-chart__header-icon reversed', {
          disabled: currentPeriod === periods.length - 1,
        })}
        onClick={handleBackClick}
      >
        <IconChevron />
      </div>
      <div className="ks-dashboard-chart__header-title">{title}</div>

      <div
        className={classNames('ks-dashboard-chart__header-icon', {
          disabled: currentPeriod === 0,
        })}
        onClick={handleForwardClick}
      >
        <IconChevron />
      </div>
    </div>
  );
};

export default PeriodSelector;
